import { Button } from "react-bootstrap";

function Header({ text }) {
  return (
    <header className="header"> 
      <h1>
        <a href="https://www.ggc.edu" target="_blank" rel="noopener noreferrer" className="text-link">
          Georgia Gwinnett College
        </a>
      </h1>
    </header>
  );
}

export default Header;
